// src/components/ad_banner/AdBanner.js (or FooterBanner.js)
import React, { useEffect, useRef, useState } from 'react';
import banner1 from '../../images/banner1.jpg';
import banner2 from '../../images/banner2.jpg';
import './adbanner.css';

const BANNER_STAY_TIME = 10000; // 10 seconds

const AdBanner = ({ images = [] }) => {
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const bannerTimerRef = useRef(null);

  // ✅ Use dynamic images from props, fallback to hardcoded banners
  const defaultBanners = [banner1, banner2];
  const banners = images.length > 0 
    ? images.map(img => img.image_url) 
    : defaultBanners;

  // ✅ Log when images prop changes
  useEffect(() => {
    console.log('AdBanner received images prop:', images);
    console.log('Using banners:', banners);
  }, [images]);

  // ✅ Reset index when images change
  useEffect(() => {
    setCurrentBannerIndex(0);
  }, [images.length]);

  // ✅ Rotation interval
  useEffect(() => {
    if (banners.length === 0) return;

    startBannerRotation();
    return () => {
      if (bannerTimerRef.current) {
        clearInterval(bannerTimerRef.current);
      }
    };
  }, [banners.length]);

  const startBannerRotation = () => {
    if (bannerTimerRef.current) {
      clearInterval(bannerTimerRef.current);
    }

    bannerTimerRef.current = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, BANNER_STAY_TIME);
  };

  // ✅ Don't render if no banners
  if (banners.length === 0) {
    return null;
  }

  return (
    <div className="footer-banner-container">
      <img
        key={banners[currentBannerIndex]} // ✅ Force re-render on image change
        className="footer-banner-img"
        src={banners[currentBannerIndex]}
        alt={`Advertisement ${currentBannerIndex + 1}`}
        onError={(e) => {
          console.error('Banner image failed to load:', banners[currentBannerIndex]);
          // Fallback to default banner if dynamic image fails
          if (images.length > 0) {
            e.target.src = defaultBanners[currentBannerIndex % defaultBanners.length];
          }
        }}
      />
      
      {/* ✅ Optional: Add dots indicator if multiple banners */}
      {banners.length > 1 && (
        <div className="banner-dots">
          {banners.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentBannerIndex ? 'active' : ''}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdBanner;